import { FormNumberField } from "@pharmupp/p3-front-commons"
import { fields } from "../../GeneralInfos.fields"
import { RPPSIdLength } from "../../GeneralInfos.rg"
import { useConditionalRppsField } from "../useConditionalRppsField"

const format = Array.from({ length: RPPSIdLength }, () => "#").join("")

export const ConditionalRppsField = () => {
  const { required } = useConditionalRppsField()

  return (
    <FormNumberField
      name={fields.rppsId}
      label="Numéro RPPS"
      required={required}
      format={format}
    />
  )
}
